export const MAX_WIDTH = 970;
export const MAX_HEIGHT = 744;
export const MOB_INTEND = 20;
export const SWIPE_TYPE_END = 'end';
